export enum HallowCartGrant {
  DiscountGrant = "discount_grant",
  TrialEndDate = "trial_end_date_grant",
}
